import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ResourceService } from '../../shared/services/resource.service';
import { Observable, catchError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ErrorService } from '../../shared/services/error.service';
import { Demo } from '../models/demo.model';

@Injectable({
    providedIn: 'root'
})
export class DemoService extends ResourceService<Demo, Demo, Demo> {
    private apiUrl = environment.apiConfig[0].uri;
    private httpClient = inject(HttpClient);
    private errorService = inject(ErrorService);
    constructor() {
        super('demo');
    }

    // Override the base getAll method to fetch all Demo items
    public override getAll(): Observable<Demo[]> {
        return this.httpClient
            .get<Demo[]>(`${this.apiUrl}/demo`)
            .pipe(catchError(this.errorService.handleError<Demo[]>('getAll demo')));
    }
}
